define('atlas/AtlasThumbsPlayer', ['atlas/AtlasPlayer', 'atlas/AtlasClientCapabilities'], function (AtlasPlayer, AtlasClientCapabilities) {
    'use strict';

    function AtlasThumbsPlayer(options, callback) {
        this._options = options || {};
        this._startingImage = options.startingImage;
        this._options.capabilities = options.capabilities || {};
        this._asset = options.asset || null;
        this._showLoadingSequenceTip = options.showLoadingSequenceTip || this.showLoadingSequenceTip;
        this._displayingThumbnails = typeof options.displayingThumbnails === 'undefined' ? true : options.displayingThumbnails;
        this._priorityImages = typeof options.priorityImages === 'undefined' ? [] : options.priorityImages;
        this._onLoadingStarted = options.onLoadingStarted || function() { };
        this._onLoadingCompleted = options.onLoadingCompleted || function() { };
        this._onThumbnailClicked = options.onThumbnailClicked || function(view) { };
        this._alwaysSendLoadingSequenceEvents = options.alwaysSendLoadingSequenceEvents || false;
        this._staticImageClassSelector = options.staticImageClassSelector || '.spinner-static-image';
        this._shotImageSelector = options.shotImageSelector || '.shot-image';
        this._thumbnailClassSelector = options.thumbnailClassSelector || '.thumb-box';
        this._thumbnailStripClassSelector = options.thumbnailStripClassSelector || '.thumb-box-main';
        this._thumbnailSelectedClass = options.thumbnailSelectedClass || 'thumb-curr';
        this._thumbnailRotatesViewer = typeof options.thumbnailRotatesViewer === 'undefined' ? true : options.thumbnailRotatesViewer;
        this._interactivityEnabled = false;
        this._playerDragged = false;
        this._callback = callback;
        this._currentTag = null;
        this._shotElement = null;
        this._shotContext = null;

        if (!this._options.assetId) {
            return;
        }

        /////////////////////////////////////////
        // set the options for loading, content URL, limited latitudes, callbacks
        /////////////////////////////////////////
        var that = this;
        var onProgress = function(progress) {
            if (that._options.onProgress) {
                that._options.onProgress(progress);
            }

            if (that._onLoadingStarted) {
                if (progress.imageCount === 1) {
                    that._onLoadingStarted(that._options.assetId);
                }
            }
            if (that._onLoadingCompleted) {
                if (progress.imageCount === progress.imageTotal) {
                    that._onLoadingCompleted(that._options.assetId);
                }
            }
        };

        var that = this;
        var onInteractivityEnabled = function() {
            that._interactivityEnabled = true;

            if (that._options.onInteractivityEnabled) {
                that._options.onInteractivityEnabled();
            }
            that._showLoadingSequenceTip(AtlasThumbsPlayer.States.Loaded);
        };

        var defaults = {
            asset: null,
            contentUrl: null,
            startingImage: this._startingImage,
            displayingThumbnails: this._displayingThumbnails,
            priorityImages: this._priorityImages,
            initialView: this._options.initialView || 'F01',
            capabilities: {
                windowDimensions: options.capabilities.windowDimensions || { width: 300, height: 300 }
            },
            onError: this._options.onError || function(severity, message) {
                //console.log(message);
            },
            onAfterImageChanged: this._options.onAfterImageChanged || function(oldView, newView) {
            },
            configurationUrl: this._options.configurationUrl,
            onInteractivityEnabled: onInteractivityEnabled,
            onProgress: onProgress,
            assetId: this._options.assetId
        };

        if ((this._startingImage) && (this._startingImage.type === 'atlas')) {
            defaults.initialView = this._startingImage.view;
        }

        if (this._asset) {
            defaults.asset = this._asset;
        }
        else {
            defaults.contentUrl = this._options.contentUrl || 'http://s3.amazonaws.com/atlas-content.turbosquid.com/assets/' + this._options.assetId + '/index.jsonp.js';
        }

        var that = this;
        jQuery('#controlArea').bind({
            mousedown: function() {
                if ((that._interactivityEnabled) && (!that._playerDragged || that._alwaysSendLoadingSequenceEvents)) {
                    that._showLoadingSequenceTip(AtlasThumbsPlayer.States.Dragged);
                    that._playerDragged = true;
                }
            },
            touchstart: function() {
                if ((that._interactivityEnabled) && (!that._playerDragged || that._alwaysSendLoadingSequenceEvents)) {
                    that._showLoadingSequenceTip(AtlasThumbsPlayer.States.Dragged);
                    that._playerDragged = true;
                }
            },
            mouseup: function() {
                if (that._interactivityEnabled) {
                    that._showLoadingSequenceTip(AtlasThumbsPlayer.States.AfterDrag);
                }
            },
            touchend: function() {
                if (that._interactivityEnabled) {
                    that._showLoadingSequenceTip(AtlasThumbsPlayer.States.AfterDrag);
                }
            }
        });
        this._showLoadingSequenceTip(AtlasThumbsPlayer.States.Loading);

        /////////////////////////////////////////
        // make thumbnails clickable
        /////////////////////////////////////////
        var that = this;
        jQuery(this._thumbnailClassSelector).bind({
            click: function() {
                //highlight the current thumbnail
                var thumbs = jQuery(that._thumbnailStripClassSelector).find('.' + that._thumbnailSelectedClass);
                thumbs.removeClass(that._thumbnailSelectedClass);
                jQuery(this).addClass(that._thumbnailSelectedClass);

                //as good as a drag?
                if ((that._interactivityEnabled) && (!that._playerDragged) && (that._options.thumbnailClickIsDrag)) {
                    that._showLoadingSequenceTip(AtlasThumbsPlayer.States.Dragged);
                    that._playerDragged = true;
                }

                //rotate to that view
                var view = jQuery(this).data('view');
                if (view) {
                    if (!that._viewer.isLoaded()) {
                        that._viewer.load();
                    }
                    that.displayViewer(view);
                }
                var tag = jQuery(this).data('tag');
                if (tag) {
                    that.displayShot(tag);
                }

                that._onThumbnailClicked(view, tag);
            }
        });

        /////////////////////////////////////////
        // load the player
        /////////////////////////////////////////
        var that = this;
        this._viewer = new AtlasPlayer(defaults, this._asset, function() {
            var capabilities = AtlasClientCapabilities.getCapabilities();
            if (capabilities.renderToCanvas) {
                that._shotElement = document.createElement('canvas');
                that._shotContext = that._shotElement.getContext('2d');

                var devicePixelRatio = window.devicePixelRatio || 1;
                var backingStoreRatio = that._shotContext.webkitBackingStorePixelRatio ||
                                        that._shotContext.mozBackingStorePixelRatio ||
                                        that._shotContext.msBackingStorePixelRatio ||
                                        that._shotContext.oBackingStorePixelRatio ||
                                        that._shotContext.backingStorePixelRatio || 1;
                var ratio = devicePixelRatio / backingStoreRatio;

                //set the canvas size based on the resolution
                if (capabilities.resolution === '2k') {
                    that._shotElement.width = ratio * 2000;
                    that._shotElement.height = ratio * 2000;
                } else if (capabilities.resolution === '1200') {
                    that._shotElement.width = ratio * 1200;
                    that._shotElement.height = ratio * 1200;
                } else if (capabilities.resolution === '300') {
                    that._shotElement.width = ratio * 300;
                    that._shotElement.height = ratio * 300;
                } else {
                    that._shotElement.width = ratio * 600;
                    that._shotElement.height = ratio * 600;
                }

                //set the css style dimensions based on the specified windowDimensions
                that._shotElement.style.width = capabilities.windowDimensions.width + 'px';
                that._shotElement.style.height = capabilities.windowDimensions.height + 'px';
                that._shotElement.style.display = 'none';

                jQuery(that._shotImageSelector)[0].appendChild(that._shotElement);
            }
            else {
                that._shotElement = jQuery(that._shotImageSelector)[0];
            }

            if (that._callback) {
                if (that._startingImage) {
                    if (that._startingImage.type === 'atlas') {
                        that.displayViewer(that._startingImage.view);
                    }
                    else if (that._startingImage.type === 'shot') {
                        that.displayShot(that._startingImage.tag);
                    }
                }
                that._callback();
            }
        });
    }

    /////////////////////////////////////////
    // loading states
    /////////////////////////////////////////
    AtlasThumbsPlayer.States = {
        Loading: 1,
        Loaded: 2,
        Dragged: 3,
        AfterDrag: 4
    };


    /////////////////////////////////////////
    // create the loading interactivity ui
    /////////////////////////////////////////
    AtlasThumbsPlayer.prototype.showLoadingSequenceTip = function(state) {
    };

    AtlasThumbsPlayer.prototype.displayShot = function(tag) {
        var url = this._viewer.getImageAdapter().getLargeImageForShot(tag);

        if (url) {
            this._currentTag = tag;
            var image = new Image();
            var that = this;
            image.onload = function() {
                //make sure the parent and child is shown
                jQuery(that._shotImageSelector).show();
                jQuery(that._shotElement).show();

                if (that._shotContext) {
                    that._shotContext.imageSmoothingEnabled = false;
                    that._shotContext.drawImage(image, 0, 0, that._shotElement.width, that._shotElement.height);
                }
                else {
                    jQuery(that._shotElement).html('<img src="' + url + '"></img>');
                }

                //if the viewer is not yet loaded, and there is a default spinner image, then swap out the
                //static image with that one
                /* jshint camelcase:false */
                if (!that._viewer.isLoaded() && that._asset.first_image) {
                    jQuery(that._staticImageClassSelector).attr('src', that._asset.first_image);
                }
            };
            image.src = url;
        }
    };

    AtlasThumbsPlayer.prototype.getCurrentShot = function() {
        return this._currentTag;
    };

    AtlasThumbsPlayer.prototype.displayViewer = function(view, forceRotation) {
        jQuery(this._shotElement).hide();

        if (!this._viewer.isLoaded()) {
            this._viewer.load(view);
        }
        else {
            if (this._interactivityEnabled) {
                this._viewer.enableInteractivity();
                if (this._thumbnailRotatesViewer || forceRotation) {
                    this._viewer.rotateTo(view);
                }
            }
        }
    };

    AtlasThumbsPlayer.prototype.getPlayer = function() {
        return this._viewer;
    };

    AtlasThumbsPlayer.prototype.isInteractivityEnabled = function() {
        return this._viewer.isInteractivityEnabled();
    };

    AtlasThumbsPlayer.prototype.getSmallImageForShot = function(tag) {
        return this._viewer.getImageAdapter().getSmallImageForShot(tag);
    };

    AtlasThumbsPlayer.prototype.getSmallImageForView = function(view) {
        return this._viewer.getImageAdapter().getSmallImageForView(view);
    };

    AtlasThumbsPlayer.prototype.nextImage = function(callback) {
        var thumbnails = jQuery(this._thumbnailClassSelector);

        var currentItem = jQuery(this._thumbnailClassSelector + '.' + this._thumbnailSelectedClass);
        var currentIndex = thumbnails.index(currentItem);
        var nextIndex = (currentIndex + 1) % thumbnails.length;

        var nextItem = thumbnails.eq(nextIndex);

        currentItem.removeClass(this._thumbnailSelectedClass);
        nextItem.addClass(this._thumbnailSelectedClass);
        nextItem.click();

        if (callback) {
            callback(currentIndex, nextIndex);
        }
    };

    AtlasThumbsPlayer.prototype.previousImage = function(callback) {
        var thumbnails = jQuery(this._thumbnailClassSelector);

        var currentItem = jQuery(this._thumbnailClassSelector + '.' + this._thumbnailSelectedClass);
        var currentIndex = thumbnails.index(currentItem);
        var previousIndex = (currentIndex - 1) >= 0 ? (currentIndex - 1) : (thumbnails.length - 1);

        var previousItem = thumbnails.eq(previousIndex);

        currentItem.removeClass(this._thumbnailSelectedClass);
        previousItem.addClass(this._thumbnailSelectedClass);
        previousItem.click();

        if (callback) {
            callback(currentIndex, previousIndex);
        }
    };

    AtlasThumbsPlayer.prototype.resizeWindow = function(windowSize) {
        if (this._viewer) {
            this._viewer.resizeWindow(windowSize);
        }
    };

    return AtlasThumbsPlayer;
});
